// frontend/src/components/admin/ConsumptionChart.jsx

import React from 'react';
import { Line, Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ConsumptionChart = ({ data, type = 'line' }) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-center text-gray-500 py-8">
        Aucune donnée disponible
      </div>
    );
  }

  // Préparer les données pour le graphique
  const labels = data.map((entry) => {
    const date = new Date(entry.timestamp || entry.capturedAt);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  });

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Puissance (W)',
        data: data.map((entry) => entry.power || entry.consumption?.power || 0),
        borderColor: 'rgb(59, 130, 246)',
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        yAxisID: 'y',
        tension: 0.4,
      },
      {
        label: 'Énergie (kWh)',
        data: data.map((entry) => entry.energy || entry.consumption?.energy || 0),
        borderColor: 'rgb(16, 185, 129)',
        backgroundColor: 'rgba(16, 185, 129, 0.1)',
        yAxisID: 'y1',
        tension: 0.4,
      },
      {
        label: 'Coût TTC (FCFA)',
        data: data.map((entry) => entry.costTTC || entry.costs?.totalCost || 0),
        borderColor: 'rgb(249, 115, 22)',
        backgroundColor: 'rgba(249, 115, 22, 0.1)',
        yAxisID: 'y2',
        tension: 0.4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            label += context.parsed.y.toFixed(2);
            
            if (label.includes('Puissance')) {
              label += ' W';
            } else if (label.includes('Énergie')) {
              label += ' kWh';
            } else if (label.includes('Coût')) {
              label += ' FCFA';
            }
            
            return label;
          },
        },
      },
    },
    scales: {
      y: {
        type: 'linear',
        display: true,
        position: 'left',
        title: {
          display: true,
          text: 'Puissance (W)',
        },
      },
      y1: {
        type: 'linear',
        display: true,
        position: 'right',
        title: {
          display: true,
          text: 'Énergie (kWh)',
        },
        grid: {
          drawOnChartArea: false,
        },
      },
      y2: {
        type: 'linear',
        display: false,
        position: 'right',
      },
    },
  };

  const ChartComponent = type === 'bar' ? Bar : Line;

  return (
    <div style={{ height: '400px' }}>
      <ChartComponent data={chartData} options={options} />
    </div>
  );
};

export default ConsumptionChart;